module.exports = __webpack_public_path__ + "img/5a10f515-4902-452b-8099-01faa2f665cc.9c2b393e.png";